export const PERMS = {
    READ: 'report_vehicle_profits.read',
    EXPORT: 'report_vehicle_profits.export',
}
